export default __webpack_public_path__ + "static/retail-90901c4311759a9446ee9c04c5502a69.svg";